module.exports = __webpack_public_path__ + "static/media/signalShort.17a7ab9f.wav";